import { useState } from 'react';
import { Modal, Form, Select, Input, message } from 'antd';
import { inspectionReportReviewService } from '@/services/inspectionReportReview.service';
import { InspectionItemStatus } from '@/shared/enums/InspectionStatus';

const { TextArea } = Input;

const RETURN_REASONS = [
  { value: 'Correção de dados', label: 'Correção de dados' },
  { value: 'Complementação de informações', label: 'Complementação de informações' },
  { value: 'Documentação adicional', label: 'Documentação adicional' },
  { value: 'Outro', label: 'Outro' },
];

interface ReturnAfterApprovalModalProps {
  open: boolean;
  inspectionItemId: string;
  onClose: () => void;
  onSuccess: (newStatus: InspectionItemStatus) => void;
}

export function ReturnAfterApprovalModal({
  open,
  inspectionItemId,
  onClose,
  onSuccess,
}: ReturnAfterApprovalModalProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await inspectionReportReviewService.returnAfterApproval(inspectionItemId, {
        reason: values.reason,
        description: values.description,
      });

      message.success('Laudo devolvido para a prestadora com sucesso');
      form.resetFields();
      onSuccess(InspectionItemStatus.DevolvidoPeloBancoAposAceite);
      onClose();
    } catch (error: any) {
      if (error?.errorFields) return; // validation error
      message.error(error?.message || 'Erro ao devolver laudo');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Devolver Laudo para Prestadora"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      okText="Confirmar Devolução"
      cancelText="Cancelar"
      confirmLoading={loading}
      okButtonProps={{ danger: true }}
    >
      <p style={{ marginBottom: 16, color: '#595959' }}>
        O laudo já foi aceito. Informe o motivo da devolução para que a prestadora possa realizar as correções necessárias.
      </p>

      <Form form={form} layout="vertical">
        <Form.Item
          name="reason"
          label="Motivo da Devolução"
          rules={[{ required: true, message: 'Selecione o motivo' }]}
        >
          <Select
            placeholder="Selecione o motivo"
            options={RETURN_REASONS}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label="Descrição"
          rules={[{ required: true, message: 'Descreva o que precisa ser corrigido' }]}
        >
          <TextArea
            rows={4}
            placeholder="Descreva detalhadamente o que precisa ser corrigido ou complementado..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
